<template>
  <div>
    <v-card max-width="600px">
      <v-card-title>
        <h1>{{bike != null ? bike.name : ''}} - Todos</h1>
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-tile v-for="todoItem in bike.todos" :key="todoItem.id">
            <v-list-tile-content>
              <v-switch :label="todoItem.text" :input-value="todoItem.checked" @change="updateCheckBox(todoItem, $event)"></v-switch>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple @click="showEditDialog(todoItem)" :title="$vuetify.t('$vuetify.todo.editbtn')">
                <v-icon color="grey lighten-1">edit</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card-text>

      <v-btn color="primary" dark fixed :small="isMobile" bottom right fab :title="$vuetify.t('$vuetify.todo.addfab')" @click="showNewDialog">
        <v-icon>add</v-icon>
      </v-btn>
    </v-card>


    <v-dialog v-model="showDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{editItem? $vuetify.t('$vuetify.todo.dialog.edittitle') : $vuetify.t('$vuetify.todo.dialog.newtitle')}}</v-card-title>

        <v-card-text>
          <v-text-field v-model="dialogContent" placeholder="Todo" @keyup.enter="dialogOk" :rules="inputRules"></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat outline @click="showDialog = false" v-if="!editItem" v-html="$vuetify.t('$vuetify.cancel')">
            Cancel
          </v-btn>
          <v-btn flat outline @click="clickDeleteTodo" v-if="editItem" v-html="$vuetify.t('$vuetify.delete')">
            Delete
          </v-btn>

          <v-btn flat outline @click="dialogOk" v-html="$vuetify.t('$vuetify.ok')">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import StringMixinx from '../mixins/StringMixin'
  import {eventBus} from '../main';

  export default {
    mixins: [StringMixinx],
    name: 'Todos',
    data() {
      return {
        showDialog: false,
        dialogContent: '',
        editItem: null,
        isMobile: false,
        inputRules: [
          v => !!v || this.$vuetify.t('$vuetify.errormsg.required'),
          v => v.length >= 3 || this.$vuetify.t('$vuetify.errormsg.minlength')
        ],
      }
    },
    computed: {
      ...mapGetters([]),
      bikeId() {
        return this.$route.params.bikeId;
      },
      bike() {
        var bike = this.$store.getters.bike(this.bikeId);
        if (bike) {
          eventBus.$emit('title-change', bike.name + ' - ToDos');
        }
        return bike;
      }
    },
    mounted() {
      this.onResize();
      window.addEventListener('resize', this.onResize, {passive: true});
    },
    beforeDestroy() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, {passive: true})
      }
    },
    methods: {
      ...mapActions([
        'updateTodo',
        'addTodo',
        'deleteTodo'
      ]),
      onResize() {
        this.isMobile = window.innerWidth < 900
      },
      updateCheckBox(item, checked) {
        this.updateTodo({bikeId: this.bikeId, todoId: item.id, checked: checked});
      },
      showEditDialog(item) {
        this.dialogContent = item.text;
        this.editItem = item;
        this.showDialog = true;
      },
      showNewDialog() {
        this.dialogContent = '';
        this.editItem = null;
        this.showDialog = true;
      },
      dialogOk() {
        if (!this.isNullOrEmpty(this.dialogContent)) {
          if (this.editItem) {
            this.updateTodo({bikeId: this.bikeId, todoId: this.editItem.id, text: this.dialogContent});
          } else {
            this.addTodo({text: this.dialogContent, checked: false, bikeId: this.bikeId})
          }
          this.showDialog = false;
        }
      },
      clickDeleteTodo() {
        this.deleteTodo({bikeId: this.bikeId, todoId: this.editItem.id});
        this.showDialog = false;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .v-btn--bottom:not(.v-btn--absolute) {
    bottom: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Todo.vue